import "./PageGuidelines.scss";
import "./PageGuidelinesMobile.scss";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import SlidingHeader from "../SlidingHeader/SlidingHeader";
import TitleDialogue from "../Assets/Design/TitleDialogue.png";
import lalamove from "../Assets/Design/lalamove.png";
import lbc from "../Assets/Design/lbc.png";
import grab from "../Assets/Design/grab.png";
import shopee from "../Assets/Design/shopee.png";
import bpicard from "../Assets/Design/bpicard.png";
import bdocard from "../Assets/Design/bdocard.png";
import gcashcard from "../Assets/Design/gcashcard.png";
import shopeecard from "../Assets/Design/shopeecard.png";
import vid from "../Assets/Design/GuidelinesBannner.mp4";
import guidelinesBack from "../Assets/Design/guidelines-back.jpg";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageGuidelines() {
  const location = useLocation();

  useEffect(() => {
    const section = location?.state?.section;
    if (section) {
      // small timeout to allow layout/rendering
      setTimeout(() => {
        const el = document.querySelector(`.${section}`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 80);
    }
  }, [location]);

  return (
    <>
      <SlidingHeader />
      <div className="guidelines-container">
        <Navbar />
        <video
          key={vid}
          autoPlay
          muted
          loop
          playsInline
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        >
          <source src={vid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <img className="background" src={guidelinesBack} />
        <div className="preorder">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">PRE-ORDER</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                Pre-ordering offers you the opportunity to reserve a spot for your chosen items before they are officially released. 

                To pre-order, you can message us or comment on the post itself. 
                
                If, for any reason, your order does not meet the supplier's cutoff or if we are unable to fulfill your pre-ordered items due to unforeseen circumstances, you have the choice of receiving a refund or transferring the amount as store credit to be used for your other pre-ordered items.`}
              </span>
            </div>
          </div>
        </div>
        <div className="item-condition">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">ITEM CONDITION</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                ITEM CONDITION will be stated for transparency.

                You can trust that all items available for pre-order are in MISB (Mint in Sealed Box) condition and are 100% authentic. 
                
                While we take every precaution to keep your items safe and free from damage, we cannot guarantee that the item will always be in perfect mint condition. (This is applicable on all items the store offers)
                
               `}
              </span>
            </div>
          </div>
        </div>
        <div className="downpayment">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">DOWNPAYMENT</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                Downpayment per item is necessary in order to reserve your slot on a specific item to minimize JOY DIBBING on the store's offered items. 

                STRICTLY NO DOWNPAYMENT POLICY IS IMPLEMENTED (See MODE OF PAYMENT) 
                
                Your order will be acknowledged and processed once the downpayment is made, and we will proceed to place the order with the supplier. (An order slip serves as a detailed record of your order, but if it's not provided immediately, rest assured that your order has already been noted.) 

                PLEASE REVIEW THE ORDER SLIP CAREFULLY TO ENSURE THAT ALL THE DETAILS ARE ACCURATE.
                `}
              </span>
            </div>
          </div>
        </div>
        <div className="estemated-arival">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">
                ESTIMATED TIME OF ARRIVAL (ETA)
              </span>
            </div>
            <div className="content-wrapper1">
              <span>
                {`
                Please note that the ETA is just an estimate and not guaranteed. These items may arrive either earlier or later than the initial ETA provided by the toy manufacturers. 
                
                The ETA is initially given to us by the manufacturer or supplier to give us an idea of when we can expect the items to be delivered. It's important to understand that this ETA is not 100% accurate, as it can be influenced by various factors that are beyond our control. ANY DELAYS CAUSED BY UNFORSEEN CIRMCUSTANCES ARE BEYOND OUR CONTROL.`}
              </span>
            </div>
            <div className="content-wrapper2">
              <span>
                {`
               We advise AGAINST pre-ordering if you are not willing to wait for an EXTENDED period in case the ETA is SIGNIFICANTLY DISTANT. We appreciate your patience and understanding during this process
               
               Kindly be aware that the ETA mentioned in the item description refers to the Japan release date. For the PH release, it typically takes 1-2 months longer after the Japan release. It's important to note that the ETA is based on estimates from the manufacturer or distributor and is subject to change.
               
               If you notice that an item is no longer available in the market and you haven't received an arrival message from us, please don't hesitate to reach out and inquire so that we can verify with our supplier.`}
              </span>
            </div>
          </div>
        </div>
        <div className="delay">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">DELAYS</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
               ITEM DELAYS occur for various reasons, including delays in supplier manufacturing or shipment. Additionally, item deliveries often occur in batches. In some cases, specific figures may have multiple batches, which means that the distribution of items will also happen in batches.

                We kindly request that you take into consideration that if items from other toy stores become available before they do in our store, it's not fair to make direct comparisons. It's important to understand that we may have different suppliers, and items are typically distributed from manufacturers to distributors and then to retailers.

       Any delays due to unfavorable events are unavoidable and is BEYOND OUR CONTROL. Therefore, we regret to inform you that requests for refunds due to delays caused by manufacturers in releasing items are NOT CONSIDERED VALID.`}
              </span>
            </div>
          </div>
        </div>{" "}
        <div className="balance">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">BALANCE</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                Remaining balance should be paid within 7 days upon item arrival. Failure to settle your dues within the 7-day grace period automatically forfeits your downpayment.

                Acknowledging the arrival message is a must.

                You have the option to inform us if you expect a delay in payment or if you decide not to proceed with the purchase (though reserving items without intent to buy is discouraged), so we can make those items available for sale.

                Failure to respond within 7 days after the arrival message forfeits your DP and item reservation rights.
                `}
              </span>
            </div>
          </div>
        </div>
        <div className="joy-dibbing">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">JOY DIBBING</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                Joydibbing, also referred to as "joy-reserving" or "not paying/abandoning" an order, is considered UNACCEPTABLE within the toy community, especially when the individual engaging in this behavior is a seller. This practice can result in financial losses for the merchant. While it is feasible to resell items that have been abandoned, it often requires the seller to allocate additional resources to effectively handle and sell these abandoned pre-orders. At times, the expenses associated with re-marketing an item may surpass the initial acquisition cost.
                
                It's IMPORTANT to keep in mind that you are completely AWARE of the ETA for your pre- ordered items, and this allows you ample time to PREPARE for the payment.
                While we take every precaution to keep your items safe and free from damage, we cannot guarantee that the item will always be in perfect mint condition. (This is applicable on all items the store offers)
                
                There is a LAW protecting the company/seller.
 Article 1596: Where the buyer wrongfully neglects or refuses to accept and pay for the goods, the seller may maintain an action against him for damages for non- acceptance.
               `}
              </span>
            </div>
          </div>
        </div>
        <div className="cancellation">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">CANCELLATION</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                We want to emphasize that once your pre-ordered items have been confirmed or acknowledged by our page, canceling or changing them is NOT PERMITTED. The item's slot is ordered and reserved specifically for YOU at that point.
              
                We KINDLY request that you be DILIGENT and RESPONSIBLE when selecting items to reserve.

                Please understand that pre-order cancellations, regardless of the reason, DO NOT qualify for refunds.

`}
              </span>
            </div>
          </div>
        </div>
        <div className="returns">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">RETURNS</span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
                We accept item returns, provided that there is a valid reason for the return. If you happen to receive a defective figure (with missing parts or significant paint issues), please notify us as soon as possible so that we can address the issue.
                
                Prior to opening the sealed plastic pouch containing the figure, please make sure to thoroughly inspect the item for any pre-existing defects. If you discover any defects, please do not proceed with opening the pouch and report the issue to us immediately. Once the plastic pouch has been opened, it may be considered tampered with, making it difficult for us to process a refund or replacement for a defective item.
                
                We strongly recommend that buyers take photos or videos while unboxing their items as evidence in case any defects are found. However, please be assured that the items undergo quality checks at the supplier's end as well.
                `}
              </span>
            </div>
          </div>
        </div>
        <div className="item-claiming">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">
                ITEM CLAIMING <br /> (ARRIVED ITEMS)
              </span>
            </div>
            <div className="content-wrapper">
              <span>
                {`
  When your pre-ordered items have arrived, we will send you an INDIVIDUAL ARRIVAL MESSAGE. Please be aware that arrived items will be stored in our facility for a period of 14 days.
  
  If you have more than 2 pre-ordered items, and the ETAs for those additional items are close, we can offer an extension to help you save on shipping costs. Please inform us of your preference.
  
  Regarding delivery options, you can choose on our MODE OF DELIVERY. Please notify us as soon as possible about your preferred delivery method. If you would like to store your items and wait for other pre-ordered items to arrive before shipping, please inform us as soon as possible.`}
              </span>
            </div>
          </div>
        </div>{" "}
        <div className="delivery-shipment">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">DELIVERY / SHIPMENT</span>
            </div>
            <div className="content-wrapper1">
              <h1>Shipping Options & Schedule</h1>
              <h3>You may allow us to ship through the following:</h3>
              <div className="img-wrapper">
                <img src={lalamove} />
                <img src={grab} />
                <img src={lbc} />
                <img src={shopee} />
              </div>
              <h3>***Delivery fee to be paid to the rider***</h3>
            </div>
            <div className="content-wrapper2">
              <h3>Biñan, Laguna</h3>
              <ul>
                <li>any day of the week</li>
              </ul>
              <h3>Mandaluyong</h3>
              <ul>
                <li>every Saturday of the week, by schedule</li>
                <li>
                  It is highly recommended to allow the store to book the rider
                  for more efficient coordination with the courier.
                </li>
                <br />
                <li>
                  The shipping fee will be determined on the day of shipment, as
                  it can vary depending on factors such as surges in demand or
                  adverse weather conditions. This ensures that customers are
                  charged an accurate and up-to-date shipping cost based on the
                  specific circumstances at the time of shipment.
                </li>
              </ul>
            </div>
            <div className="content-wrapper3">
              <h3>
                We have several ways to claim an order Within the Philippines:
              </h3>
              <br />
              <ul>
                <li>
                  Shopee (requires a Shopee account; +9% Shopee fee) Choose from
                  JNT, GoGo Express, Flash Express, SPX
                </li>
                <br />
                <li>Lazada (requires a Lazada account; +7% Shopee fee) </li>
                <br />
                <li>Lalamove, Grab or similar on-demand courier service LBC</li>
              </ul>
            </div>
            <div className="content-wrapper4">
              <span>
                {`
              Parcels processed through Shopee and Lazada will be carefully packed in durable shipping boxes and packaging materials to minimize the risk of damage during transit. Customers have the option to request brown shipping boxes for on-demand courier services like Lalamove and Grab, although this may come with an additional cost.

              Shipping charges for In-Stock/On-Hand products will be automatically calculated by the apps during the checkout process.`}
              </span>
            </div>
          </div>
        </div>
        <div className="considerations-shopee">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">
                FEW CONSIDERATIONS TO TAKE NOTE OF WHEN USING SHOPEE:
              </span>
            </div>
            <div className="content-wrapper1">
              <span>
                {`
                It's important to be aware that Shopee will not initiate a reimbursement for your deposit in the event of item or package loss. Consequently, we will not be able to refund your deposit in cases of loss via Shopee.

                We are here to assist customers with filing claims with the relevant courier. If there are any issues related to damage, loss, refunds, or reimbursements due to mishandling by the courier, customers should raise these concerns with the courier company directly. Our team will support customers throughout the claims process to help ensure a resolution is reached.`}
              </span>
            </div>
            <div className="content-wrapper2">
              <span>
                {`Shopee applies a 9% fee to your order price to cover the charges they impose on sellers when you select this delivery method. Please note that packaging materials are not provided free of charge.
                
               If there is a situation where the Shopee or Lazada courier misses the scheduled pick-up date for your order, we will promptly notify you of this occurrence. Our goal is to keep you informed and address any potential delays or issues with the courier service to ensure a smooth and reliable shopping experience.`}
              </span>
            </div>
          </div>
        </div>
        <div className="mode-of-payment">
          <div className="content-container">
            <div className="title-wrapper">
              <span className="title-text">MODE OF PAYMENT</span>
            </div>
            <div className="content-wrap">
              <div className="content-wrapper1">
                <img src={bpicard} />
                <span>Bank of the philippine islands</span>
              </div>
              <div className="content-wrapper2">
                <img src={bdocard} />
                <span>banco de oro</span>
                <br />
              </div>
              <div className="content-wrapper3">
                <img src={gcashcard} />
                <span>gcash</span>
                <br />
              </div>
              <div className="content-wrapper4">
                <img src={shopeecard} />
                <span>shopee pay or spaylater</span>
              </div>
            </div>
            <div className="note">
              {" "}
              <div className="content-wrapper1">
                <ul>
                  {" "}
                  <li>
                    please take note that screenshot or proof of payment will be
                    requested in the order history page.
                  </li>
                  <br />
                  <li>QR CODES will also be provided upon payment.</li>
                </ul>
              </div>
              <div className="content-wrapper2">
                <ul>
                  <li>
                    please take note that screenshot or proof of payment will be
                    requested in the order history page.
                  </li>
                  <br />
                  <li>QR CODES will also be provided upon payment.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
